import React, { Component } from 'react';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import OrganizerDetailPage from './organizer-details';
import { OrganizerDetails } from "../../models/organizers";
import AppUtils from '../../apputils';


class organizerDetail extends Component {
    constructor() {
        super();
        this.state = {
            getOrganizerDetails: false,
            organizer_id: '',
            organizer_name: '',
            organizer_category: '',
            organizer_img: '',
            organizer_desc: '',
        }
        this.event_data = [];
    }

    HandleRouting = (route) => {
    
            AppUtils.HandlePageClick(this.props.componentprops, route)
       
    
    }


    componentDidMount = () => {
        this.setState({
            organizer_id: this.props.componentprops.match.params.id,
            getOrganizerDetails: true
        })
    }

    HandleGetOrganizerDetailsSuccessResponse = (res) => {
        if (res !== false) {
            let organizer_data = '';
            if (res.data.organizerdetails.rows[0].organizer_details !== undefined) {
                organizer_data = res.data.organizerdetails.rows[0].organizer_details[0]
                this.event_data = res.data.organizerdetails.rows;
               

            }
            else {
                organizer_data = res.data.organizerdetails.rows[0]
            }

            this.setState({
                getOrganizerDetails: false,
                organizer_name: organizer_data.organizer_name,
                organizer_img: organizer_data.organizer_image,
                organizer_desc: organizer_data.organizer_desc,
                organizer_category: organizer_data.organizer_category

            })
        }
        else {
            this.setState({
                getOrganizerDetails: false,

            })
        }
    }

    render() {
        return (
            <div>
                <OrganizerDetailPage {...this.props} mystate={this.state} event_list={this.event_data}
                HandleRouting={this.HandleRouting}
                />
                {((this.state.getOrganizerDetails === true) ? OrganizerDetails(this.props.PnkStore, this.state.organizer_id, this.HandleGetOrganizerDetailsSuccessResponse) : "")}
            </div>
        )
    }
}

export const OrganizerDetail = PnkConnect(organizerDetail, '');